export var SHARE_PARAMS = {
    title: '森空岛-鹰角网络官方社区',
    description: '为明日方舟、来自星尘、明日方舟：终末地等游戏玩家提供官方资讯、玩家讨论、游戏攻略、同人衍生、游戏工具等',
};
